
import React from 'react';
import { Download } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface RecommendationsHeaderProps {
  recommendationsCount: number;
  onExport: () => void;
}

const RecommendationsHeader: React.FC<RecommendationsHeaderProps> = ({ 
  recommendationsCount, 
  onExport 
}) => {
  return (
    <div className="flex flex-wrap items-center justify-between gap-4 mb-2">
      <div>
        <h3 className="text-lg font-medium">Recommendations</h3>
        <p className="text-sm text-muted-foreground">
          Based on the gaps between your current and target states
        </p>
      </div>
      
      {recommendationsCount > 0 && (
        <Button 
          variant="outline" 
          size="sm" 
          className="flex items-center gap-1"
          onClick={onExport}
        >
          <Download className="h-4 w-4" />
          <span>Export</span>
        </Button>
      )}
    </div>
  );
};

export default RecommendationsHeader;
